import { jsx as _jsx } from "react/jsx-runtime";
const COLS = "minmax(0, 1fr) 128px 134px 76px 98px 146px";
const COLS_NARROW = "minmax(0, 128px) minmax(0, 134px) minmax(0, 76px) minmax(0, 98px) minmax(0, 146px)";
export function RowsGrid({ kind, style, children, ...rest }) {
    const row = kind === "row";
    return (_jsx("div", { "data-layout": "rows-grid", "data-rows-grid": kind, ...rest, style: {
            "--rows-cols-narrow": COLS_NARROW,
            "--rows-lead-col-narrow": "1 / -1",
            display: "grid",
            gridTemplateColumns: `var(--rows-cols, ${COLS})`,
            columnGap: "var(--space-15)",
            alignItems: "baseline",
            // Header 16 16 6; rows 8 16 (E's 7 snaps to the scale). The 16px side padding is
            // given back by the negative margin, so the cells sit on the content column and the
            // hover fill bleeds past it.
            padding: row ? "var(--space-1) var(--space-2)" : "var(--space-2) var(--space-2) var(--space-075)",
            margin: "0 calc(var(--space-2) * -1)",
            borderRadius: row ? "var(--radius-panel)" : undefined,
            background: row ? "var(--rows-row-bg, transparent)" : undefined,
            cursor: row ? "pointer" : undefined,
            fontSize: "var(--type-small-size)",
            lineHeight: "var(--type-small-line)",
            fontWeight: row ? "var(--type-small-weight)" : "var(--type-small-weight-strong)",
            color: "var(--ink-2)",
            ...style,
        }, children: children }));
}
/**
 * One cell: one line, ellipsis on overflow. The caller passes the full text as `title`, so a
 * truncated value is still readable (spec: "ellipsis plus `title` attribute on overflow").
 */
export function RowCell({ lead, align, inset, overflow, style, children, ...rest }) {
    return (_jsx("span", { ...rest, style: {
            minWidth: 0,
            whiteSpace: "nowrap",
            overflow: overflow ?? "hidden",
            textOverflow: "ellipsis",
            textAlign: align,
            fontVariantNumeric: align === "right" ? "tabular-nums" : undefined,
            paddingLeft: inset ? "var(--space-15)" : undefined,
            ...(lead
                ? {
                    gridColumn: "var(--rows-lead-col, auto)",
                    fontSize: "var(--type-row-title-size)",
                    lineHeight: "var(--type-row-title-line)",
                    fontWeight: "var(--type-row-title-weight)",
                    letterSpacing: "var(--type-row-title-tracking)",
                    color: "var(--ink-1)",
                }
                : {}),
            ...style,
        }, children: children }));
}
